import { DealStatus } from '../deal/deal.types';
import { GuestSegmentTypes } from '../guestSegment/guestSegment.types';
import { ReviewSource } from '../reviewManagement/reviewManagement.type';

export enum DateRangeFilter {
  TODAY = 'today',
  LAST_7_DAYS = 'last7days',
  LAST_MONTH = 'lastMonth',
  LAST_YEAR = 'lastYear',
  CUSTOM = 'custom',
  ALL_TIME = 'allTime',
}

export interface CustomDate {
  customStart: null | string;
  customEnd: null | string;
}

export interface CustomDateGiftCard {
  startDate: null | string;
  endDate: null | string;
}

export interface LoyaltyStatisticsResponse {
  data: {
    currentActiveMembers: number;
    previousActiveMembers: number;
    currentNewCustomers: number;
    previousNewCustomers: number;
    currentPointsEarned: number;
    previousPointsEarned: number;
    currentPointsSpent: number;
    previousPointsSpent: number;
  };
}

export interface GiftCardStatisticsResponse {
  data: {
    redeemed: number;
    unclaimedRevenue: number;
    soldGiftCards: number;
  };
}

export interface SegmentStatisticsResponse {
  type: GuestSegmentTypes;
  current: number;
  previous: number;
}

export interface StatisticsDeal {
  id: number;
  name: string;
  status: DealStatus;
  startDate: string;
  soldCount: string;
  totalRevenue: string;
}

export interface DealStatisticsResponse {
  data: {
    totalDeals: string;
    totalRevenue: string;
    deals: StatisticsDeal[];
  };
}
export interface DealMixMaxResponse {
  minDeals: number;
  maxDeals: number;
  minRevenue: number;
  maxRevenue: number;
}

export interface ReviewBreakDownSources {
  source: ReviewSource;
  reviewCount: string;
  avgRating: number;
}

export interface ReviewStatisticsResponse {
  overall: {
    current: {
      total: number;
      avg: number;
    };
  };
  sources: {
    current: ReviewBreakDownSources[];
    previous: ReviewBreakDownSources[];
  };
  status: {
    current: {
      replied: number;
      unreplied: number;
      newReviews: number;
    };
    previous: {
      replied: number;
      unreplied: number;
      newReviews: number;
    };
  };
}

export interface OverviewDealFiltersProps {
  sorting: string | null;
  minRevenue: null | number;
  maxRevenue: null | number;
  minDeals: null | number;
  maxDeals: null | number;
  status: null | string;
  createdAt: null | string;
}

export interface OverviewCardProps {
  dateRange: DateRangeFilter;
  customDate: CustomDate;
}
